import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _map from "lodash/map";
import _round from "lodash/round";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
import moment from 'moment';
import { createAsyncAction } from "./utils";
import { BILL_FACTS, DATE_FORMAT } from "../constants";
import { makeGetBillById } from "../selectors";
/**
 * Returns a bill object with `amount` converted to cents.
 *
 * The backend stores `amount` in cents. For client convenience, the action
 * and reducer handle the conversion between cents and dollars so that the
 * client can assume the amount is in dollars.
 *
 * @param {Object} bill Client bill object with `amount` in dollars
 *
 * @return {Object} Updated bill with `amount` as cents
 */

var changeBillAmountToCents = function changeBillAmountToCents(bill) {
  var amount = bill.amount;

  if (amount) {
    return _objectSpread(_objectSpread({}, bill), {}, {
      amount: _round(amount * 100)
    });
  }

  return bill;
};
/**
 * Fetches the my bills fact
 */


export var fetchMyBills = createAsyncAction('fetchMyBills', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.FactorySDK.evaluateFactsV1({
        facts: [BILL_FACTS.MY_BILLS],
        parameters: {
          user_current_date: moment().format(DATE_FORMAT.STANDARD)
        }
      });
    }
  };
});
/**
 * Fetches the suggested bills fact
 */

export var fetchSuggestedBills = createAsyncAction('fetchSuggestedBills', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.FactorySDK.evaluateFactsV1({
        facts: [BILL_FACTS.SUGGESTED_BILLS],
        parameters: {
          user_current_date: moment().format(DATE_FORMAT.STANDARD)
        }
      });
    }
  };
});
export var clearSuggestedBills = createAction('clearSuggestedBills');
export var resetWorkingSuggestedBills = createAction('resetWorkingSuggestedBills');
export var stageBill = createAction('stageBill', function (bill) {
  return {
    bill: bill
  };
});
export var unstageBill = createAction('unstageBill', function (id) {
  return {
    id: id
  };
});
export var createBills = createAsyncAction('createBills', function (_ref) {
  var bills = _ref.bills,
      serverRequest = _ref.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var billsInCents = _map(bills, changeBillAmountToCents);

      return opts.MyBillsSDK.createBills({
        bills: billsInCents
      }, serverRequest);
    }
  };
});
export var deleteBill = createAsyncAction('deleteBill', function (_ref2) {
  var billId = _ref2.billId,
      serverRequest = _ref2.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MyBillsSDK.deleteBill({
        billId: billId
      }, serverRequest);
    },
    meta: {
      billId: billId
    }
  };
});
export var updateBill = createAsyncAction('updateBill', function (_ref3) {
  var bill = _ref3.bill,
      serverRequest = _ref3.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var billInCents = changeBillAmountToCents(bill);
      return opts.MyBillsSDK.updateBill({
        bill: billInCents
      }, serverRequest);
    }
  };
});
export var changeBillCategory = createAsyncAction('changeBillCategory', function (_ref4) {
  var billId = _ref4.billId,
      newCategory = _ref4.newCategory,
      newSubcategory = _ref4.newSubcategory,
      previousCategory = _ref4.previousCategory,
      previousSubcategory = _ref4.previousSubcategory,
      serverRequest = _ref4.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var getBillById = makeGetBillById();
      var bill = getBillById(state.identity, {
        billId: billId
      });

      var updatedBill = _objectSpread(_objectSpread({}, bill), {}, {
        category: newCategory,
        subcategory: newSubcategory
      });

      var billInCents = changeBillAmountToCents(updatedBill);
      return opts.MyBillsSDK.updateBill({
        bill: billInCents
      }, serverRequest);
    },
    meta: {
      billId: billId,
      newCategory: newCategory,
      newSubcategory: newSubcategory,
      previousCategory: previousCategory,
      previousSubcategory: previousSubcategory
    }
  };
});
export var setBillPaidDate = createAsyncAction('setBillPaidDate', function (_ref5) {
  var billId = _ref5.billId,
      newPaidDate = _ref5.newPaidDate,
      previousPaidDate = _ref5.previousPaidDate,
      serverRequest = _ref5.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var getBillById = makeGetBillById();
      var bill = getBillById(state.identity, {
        billId: billId
      });

      var updatedBill = _objectSpread(_objectSpread({}, bill), {}, {
        paid_date: newPaidDate
      });

      var billInCents = changeBillAmountToCents(updatedBill);
      return opts.MyBillsSDK.updateBill({
        bill: billInCents
      }, serverRequest);
    },
    meta: {
      billId: billId,
      newPaidDate: newPaidDate,
      previousPaidDate: previousPaidDate
    }
  };
});